import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import NavigationLink from './navigationLink';
import CheckinMember from '../checkins/checkinMember';
import viewHelper from '../../helpers/view';
import { withRouter } from 'react-router-dom'

class Navigation extends Component {

	render() {
		let {member, bname} = this.props;
		return (
			<nav className="navbar navbar-default navbar-fixed-top members-navbar">
				<div className="container">
					<div className="navbar-header">
						<button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#main-nav" aria-expanded="false">
							<span className="sr-only">Toggle navigation</span>
							<span className="icon-bar top-bar"></span>
							<span className="icon-bar middle-bar"></span>
							<span className="icon-bar bottom-bar"></span>
						</button>
						<Link className="navbar-brand" to={`/${bname}`}>
							<h4><b>QuikFit</b></h4>
						</Link>
					</div>

					<div className="collapse navbar-collapse" id="main-nav">
						<ul className="nav navbar-nav navbar-right">
							<li>
								<a href="#" className="dropdown-toggle profile-link" data-toggle="dropdown">{viewHelper.getInitials(member)} <b className="caret hidden-sm hidden-md hidden-lg"></b></a>
								<ul className="dropdown-menu profile-options">
									<li className="dropdown-submenu">
										<ul className="profile-menu">
											<li data-toggle='collapse' data-target='#main-nav'>
												<Link to={`/${bname}`}>
													<div className="user-initials">
														<span>{viewHelper.getInitials(member)}</span>
													</div>
													<div className="user-name-email">
														<span>{viewHelper.getFullName(member)}</span>
														<span className="small-info">{member.email}</span>
													</div>
												</Link>
											</li>
											<li className="footer-link" data-toggle='collapse' data-target='#main-nav.in'>
													<Link to={`/${bname}/change_password`}>Change Password</Link>
											</li>
											<CheckinMember />
											<li className="footer-link last" data-toggle='collapse' data-target='#main-nav.in'>
												<Link to={`/${bname}/login`}>Logout</Link>
											</li>
										</ul>
									</li>
								</ul>
							</li>
						</ul>
						<ul className="nav navbar-nav">
							<NavigationLink title="Memberships" icon="far fa-user" to={`/${bname}/memberships`}/>
							<NavigationLink title="Accounts" icon="fas fa-hand-holding-usd" to={`/${bname}/accounts`}/>
							<NavigationLink title="Book An Appointment" icon="fas fa-bookmark" to={`/${bname}/appointments/book`}/>
							<NavigationLink title="Weekly Schedule" icon="fas fa-calendar" to={`/${bname}/schedule`}/>
							<NavigationLink title="Shop Now" icon="fas fa-dollar-sign" to={`/${bname}/pos/sales`}/>
							<NavigationLink title="History" icon="fas fa-calendar" to={`/${bname}/history`}/>
						</ul>
					</div>
				</div>
			</nav>
		);
	}
}

function mapStateToProps(state, ownProps) {
	return ownProps;
}

export default withRouter(connect(mapStateToProps)(Navigation))
